<template>
    <div class="shadow-card p-10" v-if="!store.data.event.loading.value">
        <div class="grid gap-6 text-left @container">
            <span class="h2 !mb-0">Event booking details</span>

            <strong class="text-primary-dark">{{ store.data.event.details.value.name }}</strong>

            <div class="grid gap-6" v-html="label" />

            <event-documents 
                v-if="(store.data.event_booking.details.value?.available_documents ?? []).length > 0"
                
                :documents="store.data.event_booking.details.value.available_documents" 
            />

            <event-documents 
                v-else-if="store.data.event.details.value.documents_available_before_purchase.length > 0"
                
                :documents="store.data.event.details.value.documents_available_before_purchase" 
            />
        </div>
    </div>
</template>

<script setup>
    import store from "@app/booking/state/store.js"
    import EventDocuments from "@app/booking/partials/EventDocuments"
    import { computed } from "vue"

    const label = computed(() => {
        let baseString = ''

        if(store.data.event.details.value?.html?.datetime){
            baseString += store.data.event.details.value?.html?.datetime
        }

        if(store.data.event.details.value?.html?.location){
            baseString += store.data.event.details.value?.html?.location
        }

        return baseString
    })
</script>